import UserGroup from "./user-group";
import Permission from "./permission";

const PRICING_PERMISSIONS = [
  Permission.StationCreate,
  Permission.StationEdit,
  Permission.PbuCreate,
  Permission.PbuEdit,
  Permission.PbuCancel,
  Permission.PriceMovementCreate,
  Permission.PriceMovementEdit,
  Permission.PriceMovementDelete,
];

const RolePermissions = {
  [UserGroup.RetailPricing]: PRICING_PERMISSIONS,
  [UserGroup.LocqAdmin]: [],
  [UserGroup.Pricetracq]: [],
};

export default RolePermissions;
